var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c(
        "cargo-up-down-resize",
        {
          staticStyle: { height: "100%" },
          attrs: {
            "up-style": {
              display: "flex",
              flexDirection: "column",
              paddingBottom: "5px"
            },
            "down-style": {
              display: "flex",
              flexDirection: "column",
              paddingTop: "5px"
            }
          }
        },
        [
          _c("template", { slot: "up" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isEdit,
                    expression: "isEdit"
                  }
                ],
                staticClass: "section"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { no: "AddTickets", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.pm.addSlaveHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AddTickets")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "RemoveTickets", type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.pm.removeSlaveHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.RemoveTickets")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section", staticStyle: { flex: "1" } },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    no: "upGrid",
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.lclSlaves
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c("div", { staticStyle: { padding: "5px 0" } }, [
              _c(
                "div",
                { staticStyle: { float: "left" } },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.readonly &&
                            _vm.showSplitButton &&
                            _vm.viewSource != "salesDetail",
                          expression:
                            "readonly && showSplitButton && viewSource!='salesDetail'"
                        }
                      ],
                      attrs: { no: "splitClickEventHandler", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.pm.splitClickEventHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.SplitHbl")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      attrs: { no: "GetContainerNo", type: "primary" }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.GetContainerNo")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      attrs: { no: "changeSealHandler", type: "primary" },
                      on: { click: _vm.changeSealHandler }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.SealNoChangeAdfterInspection"))
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      staticStyle: { color: "green" },
                      attrs: {
                        no: "addToContainerHandler",
                        type: "info",
                        plain: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.pm.addToContainerHandler()
                        }
                      }
                    },
                    [_vm._v("↓")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      staticStyle: { color: "red" },
                      attrs: {
                        no: "removeToContainerHandler",
                        type: "info",
                        plain: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.pm.removeToContainerHandler()
                        }
                      }
                    },
                    [_vm._v("↑")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": "55px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { label: _vm.totalLabel.package }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { no: "slaveTotalQuantity" },
                            model: {
                              value: _vm.slaveTotalDesc.slaveTotalQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.slaveTotalDesc,
                                  "slaveTotalQuantity",
                                  $$v
                                )
                              },
                              expression: "slaveTotalDesc.slaveTotalQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { label: _vm.$t("SeaExport.TotalWeight") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { no: "slaveTotalWeight" },
                            model: {
                              value: _vm.slaveTotalDesc.slaveTotalWeight,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.slaveTotalDesc,
                                  "slaveTotalWeight",
                                  $$v
                                )
                              },
                              expression: "slaveTotalDesc.slaveTotalWeight"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { label: _vm.$t("SeaExport.TotalCubage") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { no: "slaveTotalCubage" },
                            model: {
                              value: _vm.slaveTotalDesc.slaveTotalCubage,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.slaveTotalDesc,
                                  "slaveTotalCubage",
                                  $$v
                                )
                              },
                              expression: "slaveTotalDesc.slaveTotalCubage"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "template",
            { slot: "down" },
            [
              _c(
                "cargo-left-right-resize",
                {
                  staticStyle: { height: "100%", "min-height": "300px" },
                  attrs: {
                    "left-style": {
                      display: "flex",
                      flexDirection: "column",
                      width: "20%"
                    },
                    "right-style": {
                      display: "flex",
                      flexDirection: "column",
                      width: "80%"
                    }
                  }
                },
                [
                  _c("template", { slot: "left" }, [
                    _c(
                      "div",
                      { staticClass: "section", staticStyle: { flex: "1" } },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { height: "100%" },
                          attrs: {
                            no: "leftGrid",
                            "grid-options": _vm.left.gridOptions,
                            "column-defs": _vm.containerColumnDefs,
                            "row-data": _vm.containers
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.left.gridApi = params.api
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("template", { slot: "right" }, [
                    _c(
                      "div",
                      { staticClass: "section", staticStyle: { flex: "1" } },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { "flex-grow": "1" },
                          attrs: {
                            slot: "right",
                            no: "rightGrid",
                            "grid-options": _vm.right.gridOptions,
                            "column-defs": _vm.usageColumnDefs,
                            "row-data": _vm.selectedContainer.containerUsage
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.right.gridApi = params.api
                            }
                          },
                          slot: "right"
                        })
                      ],
                      1
                    ),
                    _c("div", { staticStyle: { padding: "5px 0" } }, [
                      _c("div", { staticStyle: { float: "left" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.usagesTotalDesc.txtNum))])
                      ]),
                      _c(
                        "div",
                        { staticStyle: { float: "right" } },
                        [
                          _c(
                            "el-form",
                            {
                              attrs: {
                                inline: true,
                                "label-width": "55px",
                                "label-position": "left"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "auto-width",
                                  attrs: { label: _vm.totalLabel.package }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100px" },
                                    attrs: { no: "usageTotalQuantity" },
                                    model: {
                                      value:
                                        _vm.usagesTotalDesc.usageTotalQuantity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.usagesTotalDesc,
                                          "usageTotalQuantity",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "usagesTotalDesc.usageTotalQuantity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "auto-width",
                                  attrs: { label: _vm.totalLabel.weight }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100px" },
                                    attrs: { no: "usageTotalWeight" },
                                    model: {
                                      value:
                                        _vm.usagesTotalDesc.usageTotalWeight,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.usagesTotalDesc,
                                          "usageTotalWeight",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "usagesTotalDesc.usageTotalWeight"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "auto-width",
                                  attrs: { label: _vm.totalLabel.cubage }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100px" },
                                    attrs: { no: "usageTotalCubage" },
                                    model: {
                                      value:
                                        _vm.usagesTotalDesc.usageTotalCubage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.usagesTotalDesc,
                                          "usageTotalCubage",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "usagesTotalDesc.usageTotalCubage"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        2
      ),
      _c("seal-number-change-dialog", {
        attrs: {
          visible: _vm.boxNoDialog.visible,
          "prop-form-data": _vm.selectedContainer
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.boxNoDialog, "visible", $event)
          },
          sealCloseHandler: _vm.sealCloseHandler
        }
      }),
      _c("query-re-lcl-dialog", {
        attrs: { visible: _vm.querySELclDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.querySELclDialog, "visible", $event)
          },
          callback: function(rows) {
            _vm.pm.slaveAddedHandler(rows)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }